import React, { memo } from 'react'

// app inputs
import AppFormikInput from 'utlis/helpers/forms/AppFormikInput'
import AppFormikTextarea from 'utlis/helpers/forms/AppFormikTextarea'

function FormSeo(props) {
    const {
        formik,
        allowedMetaTitleLength,
        allowedMetaDescLength
    } = props

    return (
        <React.Fragment>
            {/* page border box 2 */}
            <div className="page-border-box2">
                <div className="pbb2-inner">

                    <div className="details mb-3">
                        <img src="" alt="" className="img-fluid w-100 mb-2" />
                        <p className="st-fs-13 st-text-color2">
                            Commercey generates meta data based on your product's name and its description. Search engines display a limited number of chracters,
                            so you may want to re-write page title and meta description. Use the fields below to fine-tune your product's meta data describe what you
                            offer more accurately.
                        </p>
                    </div>

                    {/* form field */}
                    <AppFormikInput
                        inputType={"text"}
                        formik={formik} // formik object
                        stFormClass={""} // class name for main wrapper
                        labelName={"Page Title"} // label name
                        // isRequired={true} // is this field is required or not to show the red star sign
                        placeholder={"Page Title"} // placeholder for the input
                        formikFieldName={"metaTitle"} // important: formik value name for the input
                        hasLimit // if input has chracter limit
                        chractersLimit={allowedMetaTitleLength} // chracter limit number
                        noErrorMessage // if you don't want to show the error message
                    />

                    {/* form field */}
                    <AppFormikTextarea
                        formik={formik} // formik object
                        stFormClass={"mb-0"} // class name for main wrapper
                        labelName={"Meta Description"} // label name
                        placeholder={"Meta Description"} // placeholder for the input
                        textareaRows={"4"} // rows for textarea
                        formikFieldName={"metaDescription"} // important: formik value name for the input
                        hasLimit // if input has chracters limit
                        chractersLimit={allowedMetaDescLength} // chracters limit number
                        noErrorMessage // if you don't want to show the error message
                    />

                </div>
            </div>
        </React.Fragment>
    )
}


export default memo(FormSeo)